import { render, staticRenderFns } from "./cashierCard.vue?vue&type=template&id=b2a26fc6&scoped=true&"
import script from "./cashierCard.vue?vue&type=script&lang=js&"
export * from "./cashierCard.vue?vue&type=script&lang=js&"
import style0 from "./cashierCard.vue?vue&type=style&index=0&id=b2a26fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a26fc6",
  null
  
)

export default component.exports